import { ClientApi } from '@ssv-website/hooks';
import type {
  ConferenceApiResponse,
  ConferenceGuestDetail,
  ConferenceRegisterPayload,
  ConferenceRegisterResult,
  ConferenceGuestUpdateResult,
} from './types';

const CONFERENCE_GUEST_API_PREFIX = '/portalWebAPI/oversea/guest';
const CONFERENCE_GUEST_DETAIL_API = `${CONFERENCE_GUEST_API_PREFIX}/detail`;
const CONFERENCE_REGISTER_API = '/portalWebAPI/oversea/conference/register';
const CONFERENCE_GUEST_UPDATE_API = `${CONFERENCE_GUEST_API_PREFIX}/update`;

export const getConferenceGuestDetail = () =>
  ClientApi.get<ConferenceApiResponse<ConferenceGuestDetail>>(
    CONFERENCE_GUEST_DETAIL_API,
    {
      cache: 'no-store',
      errorMessage: false,
    }
  );

export const registerConference2026 = (payload: ConferenceRegisterPayload) =>
  ClientApi.post(CONFERENCE_REGISTER_API, payload) as Promise<ConferenceRegisterResult>;

export const updateConferenceGuest = (payload: ConferenceRegisterPayload) =>
  ClientApi.post(CONFERENCE_GUEST_UPDATE_API, payload) as Promise<ConferenceGuestUpdateResult>;
